// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.enums.RentalManagerUserTrackingEvent

export enum RentalManagerUserTrackingEvent {
  COMPLETE_ON_BOARDING_FLOW = 'COMPLETE_ON_BOARDING_FLOW',
  FEATURE_TOUR_IA_PROPERTY_TABLE = 'FEATURE_TOUR_IA_PROPERTY_TABLE',
  OPEN_ADD_PROPERTY_MODAL = 'OPEN_ADD_PROPERTY_MODAL',
  OPEN_NEW_PAYMENTS_PAGE = 'OPEN_NEW_PAYMENTS_PAGE',
  OPEN_PAYMENTS_AGGREGATED_VIEW_MODAL = 'OPEN_PAYMENTS_AGGREGATED_VIEW_MODAL',
  REFRESH_NOTIFICATION_CENTER = 'REFRESH_NOTIFICATION_CENTER',
  RENT_GUARANTEE_DEFERRED_LISTING_ALIAS = 'RENT_GUARANTEE_DEFERRED_LISTING_ALIAS',
}

export const RentalManagerUserTrackingEvent_values = [
  RentalManagerUserTrackingEvent.COMPLETE_ON_BOARDING_FLOW,
  RentalManagerUserTrackingEvent.FEATURE_TOUR_IA_PROPERTY_TABLE,
  RentalManagerUserTrackingEvent.OPEN_ADD_PROPERTY_MODAL,
  RentalManagerUserTrackingEvent.OPEN_NEW_PAYMENTS_PAGE,
  RentalManagerUserTrackingEvent.OPEN_PAYMENTS_AGGREGATED_VIEW_MODAL,
  RentalManagerUserTrackingEvent.REFRESH_NOTIFICATION_CENTER,
  RentalManagerUserTrackingEvent.RENT_GUARANTEE_DEFERRED_LISTING_ALIAS,
] as const;
